import React from 'react'
import cx from 'classnames'
import styles from './MilestoneProgress.sass'

interface MilestoneProgressProps {
  completedCount: number
  totalCount: number
  spin?: boolean
  locked?: boolean
  size?: 'small' | 'medium' | 'big'
}

export default function MilestoneProgress({
  completedCount,
  totalCount,
  spin,
  locked,
  size = 'medium',
}: MilestoneProgressProps) {
  const scale = Math.min(completedCount / Math.max(totalCount, 1), 1)
  return (
    <div className={cx(styles.root, styles[size])}>
      <div className={cx(styles.circle, styles[size])}>
        <div
          className={styles.fill}
          style={{ transform: `scaleY(${scale})` }}
        />
        <img
          src={require('./graphic-radial.svg')}
          className={cx(styles.radial, spin && styles.spin)}
        />
        <img
          src={require('assets/images/img_milestone_progress.svg')}
          className={cx(styles.icon)}
        />
      </div>
      {locked && (
        <img
          src={require('./icon-lock.svg')}
          alt="Lock icon"
          className={cx(styles.lock, styles[size])}
        />
      )}
    </div>
  )
}
